import { useEffect, useContext, useRef } from "react";
import axios from "axios";
import { Context } from "./Reducers/Store";
import { Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom";

import Login from "./pages/Login/Login";
import EsqueciSenha from "./pages/EsqueciSenha/EsqueciSenha.js";
import ResetSenha from "./pages/ResetSenha/ResetSenha.js";
import PrimeiroAcesso from "./pages/PrimeiroAcesso/PrimeiroAcesso.js";
import EventoPublico from "./pages/EventoPublico/EventoPublico.js";
import ListaConfirmacoes from "./pages/Confirmacoes/ListaConfirmacoes.js";
import Dashboard from "./pages/Dashboard/Dashboard.js";
import DeployForm from "./pages/Deploys/DeployForm.js";
import DeployList from "./pages/Deploys/DeployList.js";
import DeployDetail from "./pages/Deploys/DeployDetail.js";
import UsuariosTargets from "./pages/Usuarios/UsuariosTargets.js";
import AmbientesList from "./pages/Ambientes/AmbientesList.js";
import MaquinasList from "./pages/Maquinas/MaquinasList.js";
import GitConfigList from "./pages/AdminCatalogs/GitConfigList.js";
import BuildConfigList from "./pages/AdminCatalogs/BuildConfigList.js";
import S3ConfigList from "./pages/AdminCatalogs/S3ConfigList.js";
import DbRestoreConfigList from "./pages/AdminCatalogs/DbRestoreConfigList.js";

import LayoutEmpty from "./pages/Layouts/LayoutEmpty.js";
import SmartRedirect from "./components/SmartRedirect/index.js";
import RequireAuth from "./RequireAuth.js";
import RequireAdmin from "./RequireAdmin.js";
import LayoutDashboard from "./pages/Layouts/LayoutDashboard.js";
import AlterarSenha from "./pages/AlterarSenha/AlterarSenha.js";

export default function App() {
	const firstLoad = useRef(true);
	const meFetchedRef = useRef(false);
	const navigate = useNavigate();
	const location = useLocation();
	const [state, dispatch] = useContext(Context);

	useEffect(() => {
		const accessToken = localStorage.getItem("jwt");
		const refreshToken = localStorage.getItem("refresh_token");
		const refreshTokenExpiresAt = localStorage.getItem("refresh_token_expires_at");

		if (accessToken)
			dispatch([
				{ type: "SET_LOGGED", payload: { accessToken, refreshToken, refreshTokenExpiresAt } },
				{ type: "SET_READY", payload: true }
			]);
		else
			dispatch([
				{ type: "SET_LOGGED", payload: null },
				{ type: "SET_READY", payload: true }
			]);
	}, [dispatch]);

	useEffect(() => {
		if (state.isLogged) {
			if (firstLoad.current) {
				firstLoad.current = false;
				if (location?.pathname === "/login") {
					navigate("/", { state: { from: { pathname: "/dashboard" } } });
				}
			}
		}
	}, [location?.pathname, navigate, state.isLogged]);

	useEffect(() => {
		if (!state.isLogged) {
			meFetchedRef.current = false;
			return;
		}
		if (meFetchedRef.current) return;
		meFetchedRef.current = true;
		axios
			.get(`${process.env.REACT_APP_API}/auth/me`, { metadata: { ignoreLoading: true } })
			.then((res) => dispatch({ type: "SET_PROFILE", payload: res.data }))
			.catch(() => { meFetchedRef.current = false; });
	}, [state.isLogged, dispatch]);

	return state.ready ?
		<Routes>
			<Route element={<LayoutEmpty />}>
				<Route path="/login" element={<Login />} />
				<Route path="/esqueci-senha" element={<EsqueciSenha />} />
				<Route path="/reset-senha" element={<ResetSenha />} />
				<Route path="/primeiro-acesso" element={<PrimeiroAcesso />} />
				<Route path="/e/:slug" element={<EventoPublico />} />
				<Route path="/confirmacoes/evento/:id" element={<ListaConfirmacoes />} />
			</Route>

			<Route element={<RequireAuth><LayoutDashboard /></RequireAuth>}>
				<Route path="/" element={<SmartRedirect />} />

				<Route path="/dashboard" element={<Dashboard />} />
				<Route path="/deploys" element={<DeployList />} />
				<Route path="/deploys/novo" element={<DeployForm />} />
				<Route path="/deploys/:id" element={<DeployDetail />} />
				<Route path="/usuarios" element={<RequireAdmin><UsuariosTargets /></RequireAdmin>} />
				<Route path="/ambientes" element={<RequireAdmin><AmbientesList /></RequireAdmin>} />
				<Route path="/maquinas" element={<RequireAdmin><MaquinasList /></RequireAdmin>} />
				<Route path="/git-configurations" element={<RequireAdmin><GitConfigList /></RequireAdmin>} />
				<Route path="/build-configurations" element={<RequireAdmin><BuildConfigList /></RequireAdmin>} />
				<Route path="/s3-configurations" element={<RequireAdmin><S3ConfigList /></RequireAdmin>} />
				<Route path="/database-restore-configurations" element={<RequireAdmin><DbRestoreConfigList /></RequireAdmin>} />
				<Route path="/alterar-senha" element={<AlterarSenha />} />
			</Route>

			<Route path="*" element={<Navigate to="/login" />} />
		</Routes> : null;
}
